export const compare = {
  Duplicate: "Dupliquer",
} as const;
